import { useEffect, useState } from "react";
import { useLocation, useParams } from "react-router-dom";
import { ServiceTypes } from "src/api/adminMemo/adminmemo-types";
import { deleteCustomLinkAsync, getCustomLinkListAsync } from "src/api/customLink/custom-link";
import { CustomLinkModel } from "src/api/customLink/custom-link-types";
import { useApiOperation } from "src/api/hooks";
import { BaseButton } from "src/components";
import AdminMemoV3 from "src/components/AdminMemoV3/AdminMemoV3";
import BaseImageUpload from "src/components/BaseImageUpload";
import BaseNewTabLink from "src/components/BaseNewTabLink";
import GoToListButton from "src/components/GoToListButton";
import { ArticleSection } from "src/components/layout/ArticleSection";
import MetaTag from "src/components/layout/MetaTag";
import RegistrationInformation from "src/components/RegistrationInformation";
import { usePartnerAuthority } from "src/hooks/usePartnerAuthority";
import useNavigate from "src/hooks/usePartnerNavigate";
import { PagePath } from "src/pages/product/details";
import { useModal } from "src/recoil/modalState/hook";
import { useToast } from "src/recoil/toast/hook";
import { ViewYmdFormat } from "src/utils";
import icGlobe from "src/assets/images/ic_globe.svg";
/* 
  외부 링크 연결 상세
 */
const BasicInfoDetail = () => {
  const navigate = useNavigate();
  const { openToast } = useToast();
  const location = useLocation();
  const { id } = useParams();
  // const { openToast } = useToast();
  const { isAuthority } = usePartnerAuthority();
  const [customLinkDetail, setCustomLinkDetail] = useState<CustomLinkModel | null>(null);
  const { setBaseModal } = useModal();
  const { executeAsync: getCustomLinkDetail } = useApiOperation(getCustomLinkListAsync);
  const { executeAsync: deleteCustomLink } = useApiOperation(deleteCustomLinkAsync);

  useEffect(() => {
    const fetchApi = async (id: string) => {
      const { data } = await getCustomLinkDetail({ id });
      console.log(data);
      setCustomLinkDetail(data.data.content[0]);
    };
    if (id) {
      fetchApi(id);
    }
  }, [id]);

  // 삭제
  const handleDeleteNCustomLink = async () => {
    if (id) {
      await deleteCustomLink({ id });
      openToast({ content: "정상적으로 삭제 되었습니다" });
      navigate(`${PagePath.customLink.list}`);
    }
  };

  return (
    <>
      <MetaTag subTitle={customLinkDetail?.name || ""} />
      <div className="contents-container__scroll">
        <div className="contents-container__wrap">
          <ArticleSection title={"링크 정보"}>
            <section className="contents-container__grid">
              <div className="contents-container__grid-index">
                <p className={""}>적용 미리보기</p>
              </div>
              <div className="contents-container__grid-contents">
                <div className="w-100">
                  <div className="custom-link-add-example">
                    <img
                      className="custom-link-add-example__icon"
                      src={customLinkDetail?.icon?.media ? (customLinkDetail.icon.media.blobUrl || customLinkDetail.icon.url || icGlobe) : icGlobe}
                      alt="link icon"
                    />
                  </div>
                </div>
              </div>
            </section>
            <section className="contents-container__grid">
              <div className="contents-container__grid-index">
                <p className={""}>아이콘</p>
              </div>
              <div className="contents-container__grid-contents">
                <div className="w-100">
                  {customLinkDetail?.icon?.media ? <BaseImageUpload
                    type="LOGO"
                    images={customLinkDetail?.icon?.media ? [{ ...customLinkDetail.icon.media, url: customLinkDetail.icon.url }] : []}
                    isOnlyView={true}
                    fileMaxLength={1}
                    accept=".png"
                  /> : <p>-</p>}
                </div>
              </div>
            </section>
            <section className="contents-container__grid">
              <div className="contents-container__grid-index">
                <p className="">링크명</p>
              </div>
              <div className="contents-container__grid-contents">
                <div>
                  <p className="font14">{customLinkDetail?.name || "-"}</p>
                </div>
              </div>
            </section>
            <section className="contents-container__grid">
              <div className="contents-container__grid-index">
                <p className="">링크 설명</p>
              </div>
              <div className="contents-container__grid-contents">
                <div>
                  <p className="font14">{customLinkDetail?.description || "-"}</p>
                </div>
              </div>
            </section>
            <section className="contents-container__grid">
              <div className="contents-container__grid-index">
                <p className="">링크</p>
              </div>
              <div className="contents-container__grid-contents">
                <div>
                  <BaseNewTabLink path={customLinkDetail?.url || ""} value={customLinkDetail?.url || "-"} ellipsis />
                </div>
              </div>
            </section>
          </ArticleSection>
          {/* 등록/수정 일시는 초 단위까지 노출 (yyyy-mm-dd hh:mm:ss) */}
          <RegistrationInformation data={customLinkDetail} dateFormat={ViewYmdFormat.FULL} />

          <AdminMemoV3 serviceId={Number(id)} serviceType={ServiceTypes.SERVICE_CUSTOM_LINK} />
        </div>
      </div>
      <div className="contents-container__btn-wrap">
        <div className="left-area d-flex">
          <GoToListButton />
        </div>
        <div className="left-area d-flex">
          {isAuthority("d") && (
            <BaseButton
              title="삭제"
              className="color-white size-large mr10"
              onClick={() => {
                setBaseModal({
                  isOpen: true,
                  title: "정말 삭제 하시겠습니까?",
                  btnRightTitle: "삭제",
                  btnLeftTitle: "취소",
                  onClick: handleDeleteNCustomLink,
                  onClose: () => setBaseModal({ isOpen: false }),
                });
              }}
            />
          )}
          <BaseButton
            title="수정"
            className="size-large"
            onClick={() => {
              const formPath = `${PagePath.customLink.form}?id=${id}`;
              navigate(formPath);
            }}
          />
        </div>
      </div>
    </>
  );
};

export default BasicInfoDetail;

//여기
